var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", [
    _c("hr"),
    _vm._v(" "),
    _c("h2", { staticClass: "oc-settings__sub-header" }, [
      _vm._v("Дополнительные настройки")
    ]),
    _vm._v(" "),
    _c("div", { staticClass: "form-group" }, [
      _c("label", { staticClass: "col-xs-2 control-label" }, [
        _vm._v("Методы:")
      ]),
      _vm._v(" "),
      _c("div", { staticClass: "col-xs-2" }, [
        _c("br"),
        _vm._v(" "),
        _c(
          "button",
          { staticClass: "oc-settings-btn", on: { click: _vm.deleteAll } },
          [_vm._v("Удалить все заявки")]
        )
      ])
    ]),
    _vm._v(" "),
    _c("div", { staticClass: "form-group" }, [
      _c("label", { staticClass: "col-xs-2 control-label" }, [
        _vm._v("Заблокированные IP:")
      ]),
      _vm._v(" "),
      _c("div", { staticClass: "col-xs-2" }, [
        _c("input", {
          directives: [
            {
              name: "model",
              rawName: "v-model.trim",
              value: _vm.ipInput,
              expression: "ipInput",
              modifiers: { trim: true }
            }
          ],
          staticClass: "oc-form__control",
          attrs: {
            type: "text",
            name: "settings[ip_blocked][]",
            placeholder: "127.0.0.1",
            autocomplete: "off"
          },
          domProps: { value: _vm.ipInput },
          on: {
            keyup: function($event) {
              if (
                !$event.type.indexOf("key") &&
                _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")
              ) {
                return null
              }
              return _vm.addIP.apply(null, arguments)
            },
            input: function($event) {
              if ($event.target.composing) {
                return
              }
              _vm.ipInput = $event.target.value.trim()
            },
            blur: function($event) {
              return _vm.$forceUpdate()
            }
          }
        }),
        _vm._v(" "),
        _c("table", { staticClass: "table" }, [
          _c(
            "tbody",
            _vm._l(_vm.settings.ip_blocked, function(ip, index) {
              return _c("tr", { key: index }, [
                _c("td", [_vm._v(_vm._s(ip))]),
                _vm._v(" "),
                _c("td", [
                  _c(
                    "a",
                    {
                      attrs: { href: "#/ordercall", clas: "inline-link" },
                      on: { click: _vm.deleteIP }
                    },
                    [_vm._v("Удалить")]
                  )
                ])
              ])
            }),
            0
          )
        ])
      ])
    ]),
    _vm._v(" "),
    _vm.ipData.length
      ? _c("div", { staticClass: "form-group" }, [
          _c("label", { staticClass: "col-xs-2 control-label" }, [
            _vm._v("IP:")
          ]),
          _vm._v(" "),
          _c("div", { staticClass: "col-xs-2" }, [
            _c("table", { staticClass: "table" }, [
              _c(
                "tbody",
                _vm._l(_vm.ipData, function(data, index) {
                  return _c("tr", { key: index }, [
                    _c(
                      "td",
                      { directives: [{ name: "copy", rawName: "v-copy" }] },
                      [_vm._v(_vm._s(data["ip"]))]
                    ),
                    _vm._v(" "),
                    _c("td", [_vm._v(_vm._s(data["count"]))]),
                    _vm._v(" "),
                    _c("td", [
                      _c(
                        "a",
                        {
                          attrs: { href: "#/ordercall", clas: "inline-link" },
                          on: {
                            click: function($event) {
                              ;(_vm.ipInput = data["ip"]), _vm.addIP()
                            }
                          }
                        },
                        [_vm._v("Блокировать")]
                      )
                    ])
                  ])
                }),
                0
              )
            ])
          ])
        ])
      : _vm._e()
  ])
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-4e0a3448", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-4e0a3448","hasScoped":false,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/webpack/vue/settings/components/extra/Extra.vue
// module id = 151
// module chunks = 0